import React from 'react';
import { IconProps } from './types';

const VolumeRouting = ({ fill = '' }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.00416 7.63645V5.57907C7.00416 5.15719 6.66154 4.81543 6.24052 4.81543C5.81864 4.81543 5.47688 5.15719 5.47688 5.57907V7.63645C4.48826 7.96373 3.82178 8.88675 3.82178 9.92736C3.82178 10.968 4.48826 11.891 5.47688 12.2183V20.603C5.47688 21.0249 5.81864 21.3666 6.24052 21.3666C6.66154 21.3666 7.00416 21.0249 7.00416 20.603V12.2183C7.99193 11.891 8.65841 10.968 8.65841 9.92736C8.65841 8.88675 7.99193 7.96373 7.00416 7.63645Z"
      fill={fill}
    />
    <path
      d="M12.7637 12.4535V5.57907C12.7637 5.15719 12.4219 4.81543 12.0001 4.81543C11.5782 4.81543 11.2364 5.15719 11.2364 5.57907V12.4518C10.2512 12.7808 9.58643 13.7038 9.58643 14.7427C9.58643 15.7816 10.2512 16.7046 11.2364 17.0336V20.6028C11.2364 21.0247 11.5782 21.3665 12.0001 21.3665C12.4219 21.3665 12.7637 21.0247 12.7637 20.6028V17.0351C13.7515 16.7087 14.4188 15.7848 14.4188 14.7442C14.4188 13.7045 13.7515 12.7808 12.7637 12.4535Z"
      fill={fill}
    />
    <path
      d="M20.1773 9.923C20.1731 8.88493 19.5075 7.96532 18.5231 7.63645V5.57907C18.5231 5.15719 18.1813 4.81543 17.7594 4.81543C17.3384 4.81543 16.9958 5.15719 16.9958 5.57907V7.63645C16.008 7.96373 15.3416 8.88675 15.3416 9.92736C15.3416 10.968 16.008 11.891 16.9958 12.2183V20.603C16.9958 21.0249 17.3384 21.3666 17.7594 21.3666C18.1813 21.3666 18.5231 21.0249 18.5231 20.603V12.2183C19.5117 11.8893 20.1782 10.9646 20.1773 9.923Z"
      fill={fill}
    />
  </svg>
);

export default VolumeRouting;
